import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import classNames from 'classnames';
import { AlertDialog } from '@ds/react-components';
import TopBar from 'common/topBar/TopBar.js';
import LoadingSpinner from 'common/loading/LoadingSpinner.js';
import ScrollableTabs from 'common/tab/ScrollableTabs.js';
import Footer from 'common/footer/Footer';
import Oops from '../error/Oops.js';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    minHeight: 48,
    // ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    marginBottom: 80,
  },
  toolbarWithTabs: {
    marginTop: 69,
  },
  tabs: {
    top: 64,
    position: 'fixed',
    width: '100%',
    backgroundColor: theme.palette.common.primaryDarker,
  },
  footer: {
    width: '100%',
    bottom: 0,
    marginTop: theme.spacing(1),
  },
  text: {
    color: theme.palette.common.gray,
    fontSize: '14px',
  },
  spacer: {
    flex: 1,
  },
  tabSelected: {
    backgroundColor: theme.palette.common.secondary,
  },
  childContent: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(2),
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
  },
  oops: {
    textAlign: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    marginLeft: '-200px',
    marginTop: '-85px',
    '& span': {
      display: 'block',
    },
    '& span.header': {
      fontSize: '32px',
      fontWeight: '700',
      lineHeight: '38.4px',
      paddingBottom: '12px',
    },
    '& span.body': {
      fontSize: '20px',
      fontWeight: '400',
      lineHeight: '30px',
      color: '#666666',
    },
    '& span.footer': {
      paddingTop: '24px',
    },
  },
});
class Layout extends React.PureComponent {
  render() {
    const {
      classes,
      topBarOpen,
      routes,
      handleDrawerOpen,
      profileRoutes,
      alert,
      handleAlertClose,
      ajaxIsLoading,
      showSpinner,
      profileName,
      currentPathName,
      showTabMenu,
      selectedTab,
      handleTabChange,
      accessDenied,
    } = this.props;

    return (
      <div className={classes.root}>
        <LoadingSpinner show={showSpinner && ajaxIsLoading} />
        <CssBaseline />
        {topBarOpen && (
          <TopBar
            handleDrawerOpen={handleDrawerOpen}
            profileItems={profileRoutes}
            profileName={profileName}
            currentPathName={currentPathName}
            showTabMenu={showTabMenu}
            tabRoutes={routes}
            selectedTab={selectedTab}
          />
        )}
        {accessDenied && (
          <div
            className={classNames(classes.content, {
              [classes.toolbarWithTabs]: true,
            })}>
            <div className={classes.toolbar} />
            <div className={classes.childContent}>
              <Oops />
            </div>
          </div>
        )}
        {!accessDenied && showTabMenu && (
          <ScrollableTabs
            items={routes}
            selected={selectedTab}
            onChange={handleTabChange}
            classes={{ root: classes.tabs, selected: classes.tabSelected }}
          />
        )}
        {!accessDenied && (
          <React.Fragment>
            <AlertDialog
              title={alert.title}
              text={alert.text}
              buttonText={alert.buttonText}
              redirectLink={alert.redirectUrl}
              open={alert.showAlert}
              handleAlertClose={handleAlertClose}
            />
            <div
              className={classNames(classes.content, {
                [classes.toolbarWithTabs]: showTabMenu,
              })}>
              <div className={classes.toolbar} />
              <div className={classes.childContent}>{this.props.children}</div>
            </div>
          </React.Fragment>
        )}
        <footer className={classes.footer}>
          <Footer />
        </footer>
      </div>
    );
  }
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool,
  topBarOpen: PropTypes.bool,
  showTabMenu: PropTypes.bool,
  routes: PropTypes.array,
  tabRoutes: PropTypes.array,
  signOutItem: PropTypes.object,
  handleDrawerOpen: PropTypes.func,
  handleDrawerClose: PropTypes.func,
  handleTabChange: PropTypes.func,
  onMenuClick: PropTypes.func,
  alert: PropTypes.object,
  ajaxIsLoading: PropTypes.bool,
  showSpinner: PropTypes.bool,
  selectedTab: PropTypes.number,
  accessDenied: PropTypes.bool,
};

export default withStyles(styles, { withTheme: true })(Layout);
